/**
 * MOCK DATA — FAQ interno + Roadmap de sugerencias
 * Sección: Comunidad → FAQ Interno / Roadmap de Ideas
 * Reemplazar por: consultas a Supabase (preguntas, respuestas, sugerencias)
 */
export const mockQuestions = [
  {
    id: 'q1',
    title: '¿Cómo manejar la objeción "no tengo dinero para empezar" en la primera cita?',
    description: 'He tenido varias citas últimamente donde el cliente entiende el valor del seguro de vida con beneficios en vida, pero al final me dicen que su presupuesto está muy ajustado. ¿Qué preguntas o metáforas usan para ayudarles a priorizar esto?',
    category: 'Ventas',
    author: 'Daniela Torres',
    authorAvatar: 'D',
    date: 'Hace 2 días',
    answersCount: 3,
    hasCuratedAnswer: true,
  },
  {
    id: 'q2',
    title: '¿Qué material visual recomiendan para explicar el IUL a clientes jóvenes (millennials)?',
    description: 'Siento que el material tradicional es muy denso. ¿Hay alguna presentación o flyer en el Resource Hub que funcione mejor para explicar el potencial de crecimiento libre de impuestos a alguien de 25-30 años?',
    category: 'Educación Financiera',
    author: 'Roberto Gómez',
    authorAvatar: 'R',
    date: 'Hace 5 horas',
    answersCount: 1,
    hasCuratedAnswer: false,
  },
  {
    id: 'q3',
    title: '¿Cuánto tiempo promedio está tomando la aprobación de la licencia estatal en Texas?',
    description: 'Acabo de pasar mi examen (¡yay!) y envié mis huellas digitales. Para los que se licenciaron recientemente en TX, ¿cuánto tardó el estado en enviarles el número de licencia oficial?',
    category: 'Onboarding',
    author: 'Luis Mendoza',
    authorAvatar: 'L',
    date: 'Hace 1 semana',
    answersCount: 5,
    hasCuratedAnswer: true,
  }
];

export const mockAnswers = {
  'q1': [
    {
      id: 'a1_1',
      text: 'Yo siempre les pregunto: "Si hoy tuvieras una emergencia médica y no pudieras trabajar por 6 meses, ¿de dónde saldría el dinero para pagar tu renta?". Eso suele cambiar la perspectiva de "es un gasto" a "es una protección de mi estilo de vida actual".',
      author: 'Ana López',
      role: 'Agente Senior',
      avatar: 'A',
      date: 'Hace 1 día',
      upvotes: 12,
      isCurated: false,
    },
    {
      id: 'a1_2',
      text: 'El problema rara vez es el dinero, suele ser la prioridad. La mejor forma de abordarlo es usando la "Técnica del Café". Les demuestro que reasignando el gasto de un café diario ($5), pueden proteger a su familia por $150 al mes. Si logras que vean el seguro como un micro-ahorro diario, la objeción desaparece. Te recomiendo revisar el entrenamiento "Maestría en Venta Consultiva" en la plataforma, ahí hacemos roleplay de esto.',
      author: 'Carlos Rodríguez',
      role: 'Director de Agencia',
      avatar: 'C',
      date: 'Hace 1 día',
      upvotes: 45,
      isCurated: true,
    },
    {
      id: 'a1_3',
      text: 'Totalmente de acuerdo con Carlos. Además, intento ajustar la propuesta. Es mejor que el cliente empiece con una póliza más pequeña (Term) que se ajuste a su presupuesto actual, a que se quede sin nada. Luego, en la revisión anual, podemos convertirla a permanente.',
      author: 'Mario López',
      role: 'Agente Licenciado',
      avatar: 'M',
      date: 'Hace 5 horas',
      upvotes: 8,
      isCurated: false,
    }
  ],
  'q2': [
    {
      id: 'a2_1',
      text: 'Busca el "Flyer: El Poder del Interés Compuesto" en la sección de Recursos. Es súper visual y muestra cómo empezar a los 25 vs a los 35 cambia drásticamente el resultado. A los millennials nos encantan los gráficos simples.',
      author: 'Sofía Reyes',
      role: 'Agente',
      avatar: 'S',
      date: 'Hace 2 horas',
      upvotes: 3,
      isCurated: false,
    }
  ],
  'q3': [
    {
      id: 'a3_1',
      text: 'Actualmente el Departamento de Seguros de Texas (TDI) está tomando entre 3 a 5 días hábiles después de recibir las huellas y el background check. Si pasan 7 días y no ves actualización en Sircon, te sugiero llamarles directamente.',
      author: 'Equipo de Soporte GFI',
      role: 'Administración',
      avatar: 'G',
      date: 'Hace 6 días',
      upvotes: 15,
      isCurated: true,
    },
    {
      id: 'a3_2',
      text: 'A mí me tardó exactamente 4 días la semana pasada. ¡Felicidades por pasar el examen!',
      author: 'Elena M.',
      role: 'Agente Nueva',
      avatar: 'E',
      date: 'Hace 5 días',
      upvotes: 2,
      isCurated: false,
    }
  ]
};

export const mockSuggestions = [
  {
    id: 's1',
    title: 'Crear un simulador de objeciones interactivo',
    description: 'Sería genial tener una herramienta en la app donde un bot de voz te ponga objeciones aleatorias ("no tengo tiempo", "es muy caro") y te grabe respondiendo para luego darte feedback.',
    author: 'Daniela Torres',
    authorAvatar: 'D',
    date: 'Hace 3 días',
    upvotes: 84,
    status: 'sugerida'
  },
  {
    id: 's2',
    title: 'Plantillas de emails para seguimiento anual',
    description: 'Muchos perdemos contacto después del primer año. Sugiero agregar una sección en Recursos con plantillas de correo para hacer los "Annual Reviews" de forma profesional.',
    author: 'Luis Mendoza',
    authorAvatar: 'L',
    date: 'Hace 1 semana',
    upvotes: 156,
    status: 'aceptada'
  },
  {
    id: 's3',
    title: 'Integración del calendario de entrenamientos',
    description: 'Poder sincronizar los Bootcamps y Webinars directamente con Google Calendar o Apple Calendar con un solo clic.',
    author: 'Mario López',
    authorAvatar: 'M',
    date: 'Hace 2 semanas',
    upvotes: 210,
    status: 'en_proceso'
  },
  {
    id: 's4',
    title: 'Modo oscuro en la plataforma',
    description: 'A veces reviso entrenamientos de noche y el fondo brillante cansa la vista. Sería ideal un toggle para modo nocturno.',
    author: 'Ana López',
    authorAvatar: 'A',
    date: 'Hace 1 mes',
    upvotes: 340,
    status: 'completada'
  },
  {
    id: 's5',
    title: 'Foro público para clientes finales',
    description: 'Crear una sección donde los clientes no licenciados puedan interactuar entre ellos y compartir sus testimonios públicamente.',
    author: 'Roberto Gómez',
    authorAvatar: 'R',
    date: 'Hace 2 meses',
    upvotes: 12,
    status: 'no_por_ahora'
  }
];